module.exports = __webpack_public_path__ + "img/co-operating.eec51d23.png";